
import React, { Component } from 'react';

export class ETC extends Component {

    render() {
        return (
            <div>
                <h1 align="center">Entity To Code</h1>

                    <br />
                <p>This is a tri-project division that runs 3 projects starting with EntityToCode.JS which is a Node Library for mathmatical tools backed with a c++ engine (node-gyp), EntityToCode.py which is a Python Library for various tools backed with a c++ engine (pybind11) and MathToCode which is a React.JS site with Mathematical Tools for anyone to use</p>
                    <h2 align="center">Links</h2>
                    <ul>
                    <li><b>entityToCode.JS </b><a href='https://www.npmjs.com/package/entitytocode'>https://www.npmjs.com/package/entitytocode</a></li>
                    <li><b>entityToCode.PY </b><a href='https://pypi.org/project/entitytocodepy-official/0.0.1/'>https://pypi.org/project/entitytocodepy-official/0.0.1/</a></li>
                    <li><b>MathToCode </b><a href='https://mathtocodegds.vercel.app'>https://mathtocodegds.vercel.app</a></li>
                    </ul>
  
            </div>
        );
    }
}
